<div class="mini-card-content">
  <div
    *ngFor="let data of statusMinicards; let i = index"
    [ngClass]="i == 1 ? 'status-mini-card' : ''"
  >
    <status-mini-card [data]="data"></status-mini-card>
  </div>
</div>
